export const InvoiceStatusEnum = {
    Draft: 'DRAFT',
    Process: 'PROCESSED',
    Open: 'OPEN',
    Review: 'REVIEW',
    Approve: 'APPROVE',
    Submit: 'SUBMITTED',
    Reject: 'REJECTED'
}